import _slicedToArray from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import { EventType } from "./defs";
import createLogger from "./logger";
import { logger } from "./util";

var Reporter = /*#__PURE__*/function () {
  function Reporter(options, middlewares) {
    _classCallCheck(this, Reporter);

    // 上报队列
    this.queue = []; // 是否延迟上报

    this.delay = false;
    this.middlewares = middlewares;
    this.delay = (options === null || options === void 0 ? void 0 : options.delay) || false;
    this.logger = createLogger((options === null || options === void 0 ? void 0 : options.silent) || false);
    this.init(options);

    if (!this.delay) {
      this.ready();
    }
  }

  _createClass(Reporter, [{
    key: "init",
    value: function init(options) {
      this.runMiddleware(function (reporter) {
        var _a;

        return (_a = reporter.init) === null || _a === void 0 ? void 0 : _a.call(reporter, options);
      });
    }
    /**
     * 设置额外上报参数
     */

  }, {
    key: "setExtraParams",
    value: function setExtraParams(params) {
      this.runMiddleware(function (reporter) {
        return reporter.setExtraParams(params);
      });
    }
    /**
     * 上报就绪
     */

  }, {
    key: "ready",
    value: function () {
      var _ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var queueItem, _queueItem, _queueItem2, params, event;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.delay = false;
                _context2.next = 3;
                return Promise.all(this.runMiddleware( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(reporter) {
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return reporter.ready();

                          case 3:
                            _context.next = 8;
                            break;

                          case 5:
                            _context.prev = 5;
                            _context.t0 = _context["catch"](0);
                            logger.warn('[Reporter.ready]中间件ready异常', _context.t0);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 5]]);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
                while (queueItem = this.queue.shift()) {
                  _queueItem = queueItem, _queueItem2 = _slicedToArray(_queueItem, 2), params = _queueItem2[0], event = _queueItem2[1];
                  this.report(params, event);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ready() {
        return _ready.apply(this, arguments);
      }

      return ready;
    }()
    /**
     * 上报
     * @param params 上报参数
     * @param event 事件类型
     */

  }, {
    key: "report",
    value: function report(params) {
      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EventType.EXPOSE;

      if (this.delay) {
        this.queue.push([params, event]);
        return;
      }

      this.logger(event, params);
      this.runMiddleware(function (reporter) {
        return reporter.report(params, event);
      });
    }
    /**
     * 曝光上报
     * @param params 上报参数
     */

  }, {
    key: "expose",
    value: function expose(params) {
      this.report(params, EventType.EXPOSE);
    }
    /**
     * 点击上报
     * @param {ReportParams} params 上报参数
     */

  }, {
    key: "click",
    value: function click(params) {
      this.report(params, EventType.CLICK);
    }
    /**
     * 执行中间件方法
     * @param fn {function}
     * @return any[]
     */

  }, {
    key: "runMiddleware",
    value: function runMiddleware(fn) {
      if (Array.isArray(this.middlewares)) {
        return this.middlewares.map(function (reporter) {
          return fn(reporter);
        });
      }

      return [];
    }
  }]);

  return Reporter;
}();
/**
 * 创建上报器
 * @param {ReporterOptions} options 上报配置
 * @param {IMiddleware[]} middlewares 上报中间件
 *
 * @return {Reporter}
 */


export { Reporter as default };
export function createReporter(options, middlewares) {
  return new Reporter(options, middlewares);
}